<script lang="ts">
  import Card, { Content } from '@smui/card';
  import { getStr, isMobileWidth } from '../../../../common/util';

  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let data;
  export let containerClass = '';
  let variantData;
  const imgSize = isMobileWidth() ? '&h=36&w=32' : '&h=48&w=41';

  $: if (data) {
    variantData = data;
  }
  function handleClick() {
    dispatch('click', data);
  }
</script>

{#if variantData}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class:c_oos-variant={variantData?.isoutOfStock}
    class:restockable-variant={variantData?.isReStockable}
    class={variantData?.selected ? `${containerClass} selected` : containerClass}
    on:click={handleClick}
  >
    {#if variantData?.isReStockable}
      <div class="restockable-text d-flex justify-content-center fw-bold">
        {@html getStr('extra.preorder.restockable')}
      </div>
    {/if}
    <Card>
      <img
        class="card-container-card-icon"
        src={variantData.variantOption?.amplienceProductBaseUrl + imgSize}
        alt="Product"
        loading="lazy"
      />
      <Content>{variantData.name}</Content>
    </Card>
  </div>
{/if}
